import {getSupplierOffer} from "@project/sdk/engineering";
import {GetSupplierOfferResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";
import {ZodError} from "zod";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierOfferKeys} from "../../../supplierOffer-keys";

export function getSupplierOfferQueryOptions(
  supplierId: string,
  catalogItemId: string,
  includeDeleted = false,
) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...supplierOfferKeys.detail({supplierId, catalogItemId}), {includeDeleted}] as const,
    queryFn: async ({signal}) => {
      const parsed = GetSupplierOfferResponse.parse(
        await getSupplierOffer(supplierId, catalogItemId, {includeDeleted}, {signal}),
      );
      if (parsed.supplierId !== supplierId || parsed.catalogItemId !== catalogItemId) {
        throw new ZodError([
          {
            code: "custom",
            path: ["catalogItemId"],
            message: "Supplier Offer response does not match the requested identity pair.",
          },
        ]);
      }
      if (
        parsed.pricingStatus === "UNPRICED"
          ? parsed.terms !== undefined || parsed.selectableForCustomerOffer
          : parsed.terms === undefined ||
            parsed.selectableForCustomerOffer !== parsed.eligibleForCatalogSupply
      ) {
        throw new ZodError([
          {
            code: "custom",
            path: ["terms"],
            message: "Supplier Offer pricing projection is inconsistent.",
          },
        ]);
      }
      return parsed;
    },
  });
}
